module.exports = __webpack_public_path__ + "static/media/hospitalicon.85d61e4c.svg";